import { render, staticRenderFns } from "./openMarketDialog.vue?vue&type=template&id=c05c9e14&scoped=true"
import script from "./openMarketDialog.vue?vue&type=script&lang=js"
export * from "./openMarketDialog.vue?vue&type=script&lang=js"
import style0 from "./openMarketDialog.vue?vue&type=style&index=0&id=c05c9e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05c9e14",
  null
  
)

export default component.exports